import {remove} from "lodash";

export default (items, maxItems = 6) => ({
    items,
    maxItems,
    draggedItem: null,
    draggingOver: null,
    selectedItem: null,

    dragStart(item) {
        this.draggedItem = item;
        item.isDragging = true;
    },

    dragEnd(item) {
        item.isDragging = false;
        this.draggedItem = null;
    },

    dragOver(event, itemId) {
        event.preventDefault();

        this.draggingOver = itemId;
    },

    dragLeave() {
        this.draggingOver = null;
    },

    drop(event, item) {
        event.preventDefault();

        if (item.id !== this.draggedItem.id) {
            const draggedIndex = this.items.findIndex(i => i.id === this.draggedItem.id);
            const targetIndex = this.items.findIndex(i => i.id === item.id);

            this.items.splice(targetIndex, 0, this.items.splice(draggedIndex, 1)[0]);
        }

        item.isDragging = false;
        this.draggedItem = null;
        this.draggingOver = null;
    },

    remove(item) {
        remove(this.items, i => i.id === item.id);
    },

    addItem() {
        if (this.items.length < this.maxItems && !this.items.some(item => item.name === this.selectedItem.name)) {
            this.items.push({
                id: this.selectedItem.id,
                name: this.selectedItem.name,
                prepaid_index: this.selectedItem.prepaid_index,
                register_type: 'before',
            });

            this.selectedItem = null;

            this.$dispatch('clear-select');

            return;
        }

        window.$wireui.notify({
            title: 'Warning',
            description: `You cannot add more than ${this.maxItems} packages or an already added package!`,
            icon: 'warning'
        });
    }
});
